/**
 * 登录 API。
 */
import { httpPost, ServerType } from "@/service/httpRequest";

export interface LoginResult {
    /** 正式 JWT，含 loginMode；企业身份时后端在 claims 中写入 tenantId */
    token?: string;
    signKey?: string;
    loginMode?: "PERSONAL" | "ENTERPRISE";
    tenantId?: number;
}

export interface PasswordLoginRequest {
    username: string;
    password: string;
    rememberMe?: boolean;
}

/** 服务端退出：使当前 JWT 与会话 signKey 立即失效 */
export function logout(): Promise<void> {
    return httpPost<void>(ServerType.Base, { url: "/auth/logout" });
}
